module.exports = __webpack_public_path__ + "static/media/22.e242bc18.mp3";